module.exports = __webpack_public_path__ + "img/evaluation.0a6fa01d.png";